import { __rest } from "tslib";
import { bool, object, string } from 'prop-types';
import React, { useMemo } from 'react';
import ReactMarkdown from 'react-markdown';
import { BodyText } from '../Type';
import preserveMarkdownLeadingAndTrailingWhitespace from './preserveMarkdownLeadingAndTrailingWhitespace';
const DEFAULT_COMPONENTS = {
    // We can replace html with our react components as below.
    // we spread the props but remove 'node' as we don't need to pass the element down to our component
    p: (_a) => {
        var { node } = _a, elementProps = __rest(_a, ["node"]);
        return React.createElement(BodyText, Object.assign({ noTopSpacer: true }, elementProps));
    },
};
export default function Markdown(props) {
    const { children, components, preserveWhitespace = false } = props, otherProps = __rest(props, ["children", "components", "preserveWhitespace"]);
    const combinedComponents = useMemo(() => (Object.assign(Object.assign({}, DEFAULT_COMPONENTS), components)), [components]);
    return (React.createElement(ReactMarkdown, Object.assign({ components: combinedComponents, children: preserveWhitespace ? preserveMarkdownLeadingAndTrailingWhitespace(children) : children }, otherProps)));
}
Markdown.propTypes = {
    children: string,
    components: object,
    preserveWhitespace: bool,
};
//# sourceMappingURL=Markdown.js.map